import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({})
export default class WaveformsContainer extends Vue {
  waveformUrl = "";

  @Getter("current", patientNamespace)
  current!: Patient;

  activePatientId: number = -1;

  @Action("redirectRequest", navigationNamespace)
  redirectRequest!: Function;

  @Watch("current")
  async currentUpdate() {
    if (this.current && this.current.id) {
      this.activePatientId = this.current.id;
    }
    if (this.activePatientId !== -1) {
      const response = await this.redirectRequest(this.current.id);
      this.waveformUrl = response;
    }
  }

  mounted() {
    this.currentUpdate();
  }
}
